import { DialogContent, DialogTitle } from "@/components/ui/dialog";

interface ImgPopProps {
    title: string;
    children: React.ReactNode;
}

export default function ImgPop({ title, children }: ImgPopProps) {
    return (
        <DialogContent className="block w-[calc(100%-40px)] max-w-[700px] gap-0 overflow-hidden rounded-[20px] bg-[#F7F6FB] p-0 [&>button>svg]:h-8 [&>button>svg]:w-8 [&>button]:right-[30px] [&>button]:top-6 [&>button]:z-[1] [&>button]:opacity-100 [&>button]:!ring-0 [&>button]:!ring-offset-0">
            <DialogTitle className="relative z-[1] border-b border-[#ddd] p-[24px_65px_16px_40px] text-[24px] font-[700]">
                {title}
            </DialogTitle>
            {children}
        </DialogContent>
    );
}
